// Зоны решений MCI-модели (CogNimbus response.zone) — английские подписи
// production-кабинета physician. Цвета согласованы с когниметром.

export interface MciZoneInfo {
  short: string;
  caption: string;
  color: string;
  chipColor: "success" | "warning" | "error" | "default";
}

export const MCI_ZONES: Record<string, MciZoneInfo> = {
  rule_out: {
    short: "Expected range",
    caption: "Performance within the expected cognitive range",
    color: "#159a47",
    chipColor: "success",
  },
  gray_zone: {
    short: "Borderline",
    caption: "Borderline result — further evaluation recommended",
    color: "#6b7280",
    chipColor: "warning",
  },
  rule_in: {
    short: "Cognitive impairment",
    caption: "Performance consistent with cognitive impairment",
    color: "#b42318",
    chipColor: "error",
  },
  severe: {
    short: "Cognitive impairment",
    caption: "Performance consistent with cognitive impairment",
    color: "#b42318",
    chipColor: "error",
  },
};

export const DEFAULT_DISCLAIMER_TITLE =
  "Cognitive assessment aid — not a diagnosis";

export const DEFAULT_DISCLAIMER =
  "Cognimeter interprets current cognitive performance as an assessment aid. "
  + "It does not identify the presence or absence of a clinical diagnosis and is not intended "
  + "as a stand-alone or adjunctive diagnostic device.";
